    ; +(function ($) {
        var CONFIG = {
            "rectangle": [
                { "width": 3.5, "length": 6.5 },
                { "width": 2.0, "length": 8.0 },
                { "width": 5.0, "length": 5.0 },
                { "width": 2.0, "length": 6.5 },
                { "width": 3.5, "length": 5.0 },
                { "width": 3.5, "length": 3.5 },
                { "width": 2.0, "length": 5.0 },
                { "width": 2.0, "length": 3.5 },
                { "width": 2.0, "length": 2.0 },
                { "width": 4.0, "length": 8.0 },
                { "width": 2.5, "length": 9.5 },
                { "width": 2.5, "length": 8.0 },
                { "width": 2.5, "length": 7.5 },
                { "width": 5.5, "length": 6.5 },
                { "width": 4.0, "length": 6.0 },
                { "width": 4.0, "length": 6.5 },
                { "width": 2.5, "length": 6.5 },
                { "width": 6.0, "length": 6.0 },
                { "width": 2.5, "length": 6.0 },
                { "width": 2.0, "length": 4.0 },
                { "width": 2.0, "length": 6.0 },
                { "width": 2.25, "length": 6.92 },
                { "width": 2.25, "length": 4.42 },
                { "width": 3.5, "length": 3.5 },
                { "width": 3.5, "length": 6.92 },
            ],
            "round": [
                { "width": 3.5 },
                { "width": 2.0 },
                { "width": 3.0 },
                { "width": 2.5 },
            ],
            "ushape": [
                { "width": 7.0, "length": 11.5, "w2": 4.5, "l2": 3.5 },
                { "width": 7.0, "length": 8.5, "w2": 4.5, "l2": 3.5 },
                { "width": 5.5, "length": 8.5, "w2": 3.0, "l2": 3.5 }
            ],
            "lshape": [
                { "width": 7.0, "length": 7.0, "w2": 4.5 },
                { "width": 5.5, "length": 5.5, "w2": 3.0 },
                { "width": 6.92, "length": 6.92, "w2": 3.46 }
            ],
            "cascading": [
                { "width": 3.5, "length": 3.5, "tall": 2.67, "t1": 1.42, "w2": 2.0, "l2": 3.5, "t2": 1.25 }
            ]
        }

        const QUERY_ID_MAP = {
            type: 'bedtype',
            unit: '',
            height: ''
        }

        var HEIGHT = [0.92, 1.42, 2.125, 2.67]

        var BASE_SOIL_HANDLE = 'vego-base-soil'
        var FINSHING_SOIL_HANDLE = 'vego-garden-finishing-soil'
        function SoilCalculator(ele) {
            var query = $.qs()
            this.$ele = $(ele)
            this.type = query.type ? query.type[0] : 'rectangle'
            this.height = query.height ? +query.height[0] : 1.42
            this.width = query.width ? +query.width[0] : undefined
            this.diameter = query.diameter ? +query.diameter[0] : undefined

            this.calcFunc = {
                rectangle: function (obj) {
                    return obj.width * obj.length * obj.height
                },
                round: function (obj) {
                    return (obj.diameter / 2) * (obj.diameter / 2) * 3.14 * obj.height
                },
                ushape: function (obj) {
                    var config = CONFIG[obj.type]
                    var cc
                    for (let c of config) {
                        if (obj.width == c.width && obj.length == c.length) {
                            cc = c
                            break
                        }
                    }
                    return (obj.width * obj.length - cc.w2 * cc.l2) * obj.height
                },
                lshape: function (obj) {
                    var config = CONFIG[obj.type]
                    var cc
                    for (let c of config) {
                        if (obj.width == c.width && obj.length == c.length) {
                            cc = c
                            break
                        }
                    }
                    return (obj.width * obj.length - cc.w2 * cc.w2) * obj.height
                },
                cascading: function (obj) {
                    var config = CONFIG[obj.type]
                    var cc
                    for (let c of config) {
                        if (obj.width == c.width && obj.length == c.length) {
                            cc = c
                            break
                        }
                    }
                    return obj.width * obj.length * cc.t1 + cc.w2 * cc.l2 * cc.t2
                }
            }

            this.$ele.find('select').select2({
                placeholder: 'Select an option',
                minimumResultsForSearch: Infinity,
                width: '100%'
            })

            if (this.type) {
                this.renderHeight()
                if (this.type != 'round') {
                    this.renderWidth()
                } else {
                    this.renderDiameter()
                }
            }

            for (var k in QUERY_ID_MAP) {
                if (this[k]) {
                    var id = QUERY_ID_MAP[k] || k
                    var value = this[k]
                    if (k == 'height') {
                        value = this[k]
                    }
                    this.$ele.find('#' + id).val(value).trigger('change')
                }
            }

            if (this.width) {
                this.$ele.find('#width').val(this.width).trigger('change')
                this.onSelectWidth()
            }

            if (this.diameter) {
                this.$ele.find('#diameter').val(this.diameter).trigger('change')
                this.updateSubmitButton(true)
                setTimeout(() => {
                    this.onSubmit()
                }, 100)
            }

            this.length = query.length ? +query.length[0] : undefined
            if (this.length) {
                this.$ele.find('#length').val(this.length).trigger('change')
                this.updateSubmitButton(true)
                setTimeout(() => {
                    this.onSubmit()
                }, 100)
            }

            this.$ele.find('#bedtype').on('select2:select', this.onSelectBedType.bind(this));
            this.$ele.find('#height').on('select2:select', this.onSelectHeight.bind(this));
            this.$ele.find('#width').on('select2:select', this.onSelectWidth.bind(this));
            this.$ele.find('#length').on('select2:select', this.onSelectLength.bind(this));
            this.$ele.find('#diameter').on('select2:select', this.onSelectDiameter.bind(this));
            this.$ele.find('.submit-btn').on('click', this.onSubmit.bind(this));
        }

        SoilCalculator.prototype.onSelectBedType = function () {
            var data = this.$ele.find('#bedtype').select2('data')
            this.type = data[0].id
            this.height = undefined
            this.width = undefined
            this.length = undefined
            this.diameter = undefined
            this.hideDynamic()
            this.renderHeight()
            if (this.type != 'round') {
                this.renderWidth()
            } else {
                this.renderDiameter()
            }
            this.updateSubmitButton(false)
            this.updateResult(false)
        }

        SoilCalculator.prototype.onSelectHeight = function () {
            var data = this.$ele.find('#height').select2('data')
            this.height = +data[0].id
            this.updateResult(false)
        }

        SoilCalculator.prototype.onSelectWidth = function () {
            var data = this.$ele.find('#width').select2('data')
            this.width = +data[0].id
            this.length = undefined
            var configs = CONFIG[this.type]
            var lengthes = []
            for (let config of configs) {
                if (this.width == config.width) {
                    if (!lengthes.some(function (e) { return e.id == config.length })) {
                        lengthes.push({
                            id: config.length,
                            text: this.formatUnitText(config.length)
                        })
                    }
                }
            }
            lengthes.sort((a, b) => a.id - b.id)
            this.renderSelect(this.$ele.find('#length'), lengthes)
            this.updateSubmitButton(false)
            this.updateResult(false)
        }

        SoilCalculator.prototype.onSelectLength = function () {
            var data = this.$ele.find('#length').select2('data')
            this.length = +data[0].id
            this.updateSubmitButton(true)
            this.updateResult(false)
        }

        SoilCalculator.prototype.onSelectDiameter = function () {
            var data = this.$ele.find('#diameter').select2('data')
            this.diameter = +data[0].id
            this.updateSubmitButton(true)
            this.updateResult(false)
        }

        SoilCalculator.prototype.onSubmit = function () {
            var _this = this
            this.$ele.find('.submit-btn').addClass('btn--loading')
            var soilPrice = {}
            window._ajaxSingleProduct({
                handle: BASE_SOIL_HANDLE
            }).then(res => {
                soilPrice.base = 1795
                if (res) {
                    soilPrice.base = res.product.variants[0].price * 100
                }
                window._ajaxSingleProduct({
                    handle: FINSHING_SOIL_HANDLE
                }).then(res => {
                    soilPrice.finishing = 1995
                    if (res) {
                        soilPrice.finishing = res.product.variants[0].price * 100
                    }
                    _this.renderResult(soilPrice)
                    _this.$ele.find('.submit-btn').removeClass('btn--loading')
                    _this.updateResult(true)
                })
            })
        }

        SoilCalculator.prototype.renderResult = function (soilPrice) {
            var func = this.calcFunc[this.type]
            var volume = Math.round(func(this))
            this.$ele.find('#total-volume').text(volume)
            if (this.height == HEIGHT[0]) {
                var bags = Math.ceil(volume / 1.5)
                var config = {
                    finishing: {
                        name: 'Vego Garden Finishing Soil',
                        volume: volume,
                        bags: bags,
                        link: '/products/' + FINSHING_SOIL_HANDLE
                    }
                }
                this.calcFee(config, soilPrice)
                config.totalFee = config.finishing.totalFee
                config.totalShippingFee = config.finishing.shippingFee
                var template = this.buildTemplate(config)
                this.$ele.find('.panel-vego .calculator-result-info, .panel-traditional .calculator-result-info').html(template)
            } else if (this.height == HEIGHT[1]) {
                var finishingVolume = volume * 0.5;
                var finsihingBags = Math.ceil(finishingVolume / 1.5)
                var config = {
                    finishing: {
                        name: 'Vego Garden <br class="small--show"> Finishing Soil',
                        volume: finishingVolume,
                        bags: finsihingBags,
                        link: '/products/' + FINSHING_SOIL_HANDLE
                    },
                    base: {
                        name: 'Vego Garden<br class="small--show"> Base Soil',
                        volume: finishingVolume,
                        bags: finsihingBags,
                        link: '/products/' + BASE_SOIL_HANDLE
                    }
                }
                this.calcFee(config, soilPrice)
                config.totalFee = config.finishing.totalFee + config.base.totalFee
                config.totalShippingFee = config.finishing.shippingFee + config.base.shippingFee
                this.$ele.find('.panel-traditional .calculator-result-info').html(this.buildTemplate(config))
                config.base.placeholder = true
                config.totalFee = config.finishing.totalFee
                config.totalShippingFee = config.finishing.shippingFee
                config.saveFee = config.base.totalFee
                this.$ele.find('.panel-vego .calculator-result-info').html(this.buildTemplate(config))
            } else if (this.height == HEIGHT[2]) {
              var finishingVolume = volume * (0.3 * 100) / 100;
              var finsihingBags = Math.ceil(finishingVolume / 1.5)
              var baseVolume = volume * (0.7 * 100) / 100
              var baseBags = Math.ceil(baseVolume / 1.5)
              var config = {
                  finishing: {
                      name: 'Vego Garden <br class="small--show"> Finishing Soil',
                      volume: finishingVolume,
                      bags: finsihingBags,
                      link: '/products/' + FINSHING_SOIL_HANDLE
                  },
                  base: {
                      name: 'Vego Garden<br class="small--show"> Base Soil',
                      volume: baseVolume,
                      bags: baseBags,
                      link: '/products/' + BASE_SOIL_HANDLE
                  }
              }
              this.calcFee(config, soilPrice)
              config.totalFee = config.finishing.totalFee + config.base.totalFee
              config.totalShippingFee = config.finishing.shippingFee + config.base.shippingFee
              this.$ele.find('.panel-traditional .calculator-result-info').html(this.buildTemplate(config))
              config.base.placeholder = true
              config.totalFee = config.finishing.totalFee
              config.totalShippingFee = config.finishing.shippingFee
              config.saveFee = config.base.totalFee
              this.$ele.find('.panel-vego .calculator-result-info').html(this.buildTemplate(config))
            } else if (this.height == HEIGHT[3]) {
                var finishingVolume = volume * 0.25;
                var finsihingBags = Math.ceil(finishingVolume / 1.5)
                var baseVolume = volume * 0.75
                var baseBags = Math.ceil(baseVolume / 1.5)
                var config = {
                    finishing: {
                        name: 'Vego Garden <br class="small--show"> Finishing Soil',
                        volume: finishingVolume,
                        bags: finsihingBags,
                        link: '/products/' + FINSHING_SOIL_HANDLE
                    },
                    base: {
                        name: 'Vego Garden<br class="small--show"> Base Soil',
                        volume: baseVolume,
                        bags: baseBags,
                        link: '/products/' + BASE_SOIL_HANDLE
                    }
                }
                this.calcFee(config, soilPrice)
                config.totalFee = config.finishing.totalFee + config.base.totalFee
                config.totalShippingFee = config.finishing.shippingFee + config.base.shippingFee
                this.$ele.find('.panel-traditional .calculator-result-info').html(this.buildTemplate(config))
                config.base.placeholder = true
                config.totalFee = config.finishing.totalFee
                config.totalShippingFee = config.finishing.shippingFee
                config.saveFee = config.base.totalFee
                this.$ele.find('.panel-vego .calculator-result-info').html(this.buildTemplate(config))
            }
        }

        SoilCalculator.prototype.calcFee = function (config, soilPrice) {
            for (var k in config) {
                var c = config[k]
                if (c.bags) {
                    c.fee = soilPrice[k] * c.bags
                    c.shippingFee = 2000 * c.bags
                    c.totalFee = c.fee + c.shippingFee
                }
            }
        }

        SoilCalculator.prototype.buildTemplate = function (config) {
            var template = ''
            if (config.finishing) {
                template += this.buildGroup(config.finishing)
            }
            if (config.base) {
                if (config.base.placeholder) {
                    template += '<div class="calculator-result-group calculator-result-group-soil"></div>'
                } else {
                    template += this.buildGroup(config.base)
                }
            }
            template += `
        <div class="calculator-result-group calculator-result-group-shipping-fee">
            <div class="calculator-result-group-line">
                <div class="calculator-result-label heading">Shipping Fee</div>
                <div class="calculator-result-desc">${theme.Currency.formatMoney(config.totalShippingFee, theme.settings.moneyFormat)}</div>
            </div>
        </div>
        `
            template += `
        <div class="calculator-result-group">
            <div class="calculator-result-group-line">
                <div class="calculator-result-label heading">Total Fee</div>
                <div class="calculator-result-desc calculator-result-desc-total">
                ${theme.Currency.formatMoney(config.totalFee, theme.settings.moneyFormat)}
                ${config.saveFee ? `<div class="calculator-result-save"><span class="highlight">Save</span> ${theme.Currency.formatMoney(config.saveFee, theme.settings.moneyFormat)}</div>` : ''}
                </div>
            </div>
        </div>
        `
            return template
        }

        SoilCalculator.prototype.buildGroup = function (config) {
            return `
        <div class="calculator-result-group ${config.name == 'Base Soil' ? 'calculator-result-group-soil' : ''}">
            <div class="calculator-result-group-line">
                <div class="calculator-result-label heading">${config.name}</div>
                <div class="calculator-result-desc">${config.volume} ft³</div>
            </div>
            <div class="calculator-result-group-line">
                <div class="calculator-result-label">Package Number</div>
                <div class="calculator-result-desc">${config.bags} Bags</div>
            </div>
            <div class="calculator-result-group-line">
                <div class="calculator-result-label">Soil Fee</div>
                <div class="calculator-result-desc">${theme.Currency.formatMoney(config.fee, theme.settings.moneyFormat)}</div>
                <div class="calculator-result-link"><a target="__blank" href="${config.link}?quantity=${config.bags}">Shop Now</a></div>
            </div>
        </div>
        `
        }

        SoilCalculator.prototype.hideDynamic = function () {
            this.$ele.find('.dynamic-input').addClass('hide')
        }

        SoilCalculator.prototype.renderHeight = function () {
            var configs = CONFIG[this.type]

            var talls = []
            for (let config of configs) {
                if (config.tall) {
                    talls.push({
                        id: config.tall,
                        text: this.formatUnitText(config.tall)
                    })
                }
            }

            if (!talls.length) {
                HEIGHT.forEach(e => {
                    talls.push({
                        id: e,
                        text: this.formatUnitText(e)
                    })
                })
            }
            this.renderSelect(this.$ele.find('#height'), talls)
        }

        SoilCalculator.prototype.renderWidth = function () {
            var widthes = []
            var configs = CONFIG[this.type]
            for (let config of configs) {
                if (!widthes.some(function (e) { return e.id == config.width })) {
                    widthes.push({
                        id: config.width,
                        text: this.formatUnitText(config.width)
                    })
                }
            }
            widthes.sort((a, b) => a.id - b.id)
            this.renderSelect(this.$ele.find('#width'), widthes)
        }

        SoilCalculator.prototype.renderDiameter = function () {
            var ds = []
            var configs = CONFIG[this.type]
            for (let config of configs) {
                ds.push({
                    id: config.width,
                    text: this.formatUnitText(config.width)
                })
            }
            ds.sort((a, b) => a.id - b.id)
            this.renderSelect(this.$ele.find('#diameter'), ds)
        }


        SoilCalculator.prototype.renderSelect = function ($ele, data, allowClear) {
            $ele.select2('destroy');
            $ele.html("<option><option>");
            $ele.select2({
                data: data,
                placeholder: 'Select an option',
                allowClear: allowClear,
                minimumResultsForSearch: Infinity,
                width: '100%'
            })
            $ele.closest('.dynamic-input').removeClass('hide')
        }

        SoilCalculator.prototype.updateSubmitButton = function (show) {
            if (show) {
                this.$ele.find('.submit-btn').removeClass('hide')
            } else {
                this.$ele.find('.submit-btn').addClass('hide')
            }
        }

        SoilCalculator.prototype.updateResult = function (show) {
            if (show) {
                this.$ele.find('.calculator-result').removeClass('hide')
            } else {
                this.$ele.find('.calculator-result').addClass('hide')
            }
        }

        SoilCalculator.prototype.formatUnitText = function (feet) {
            return '(' + feet + '\')' + Math.round(feet * 12) + '"'
        }

        jQueryBridget('soilcal', SoilCalculator)
        $('.calculator-card').soilcal()
    })(jQuery)